var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Objednať posudok")])]), _c('order-property-report-form', {
    attrs: {
      "property-info": _vm.payload
    }
  }), _vm._m(0)], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "information-wrapper"
  }, [_c('img', {
    attrs: {
      "src": require("@/images/existujuce-uvery-icon.png"),
      "width": "100",
      "alt": ""
    }
  }), _c('span', {
    staticClass: "blc-color"
  }, [_vm._v("objednávka je pre klienta "), _c('br'), _vm._v("záväzná, pričom cena posudku bude "), _c('br'), _vm._v(" 79 EUR splatných po dodaní")]), _c('div', [_c('button', {
    staticClass: "w-button saveformBtn"
  }, [_vm._v(" Uložiť a odoslať ")])])]);

}]

export { render, staticRenderFns }